import type { z } from "zod";

import type { getKnowledgeSearchSchema } from "./constants/knowledge-search";

export type TKnowledgeSearchForm = z.infer<
  ReturnType<typeof getKnowledgeSearchSchema>
>;

// NOTE: Tab values double as the `?tab=` URL value, so they stay kebab-case
// and must not change without updating existing deep links (e.g. the
// knowledge-file-shared notification CTA).
export enum EKnowledgeTab {
  MY_FILES = "my-files",
  SHARED_WITH_ME = "shared-with-me",
}
